import React from 'react';
import { Link } from 'react-router';
import { bool, func, instanceOf } from 'prop-types';

import * as urls from '../../../../actions/urlTypes';

import TargetLabelBodyRow from './TargetLabelBodyRow';

const TargetLabelBody = ({
  saveLabel,
  expressionList = [],
  loading,
  selectedTargets,
}) => {
  if (!selectedTargets) {
    return (
      <div className="de--label-table-body">
        <div className="no-taret-selected">
          <div className="no-taret-selected--title">No Target Selected!</div>
          <div className="no-taret-selected--message">
            Please{' '}
            <Link to={`${urls.APP_ROOT_URL}/datahub/targets`}>return</Link> to
            the Targets page and select a target to view in this page
          </div>
        </div>
      </div>
    );
  }
  if (loading) {
    return (
      <div className="de--label-table-body" style={{ padding: 20 }}>
        loading...
      </div>
    );
  }
  if (expressionList.length === 0) {
    return (
      <div className="de--label-table-body" style={{ padding: 20 }}>
        No Expression found!!
      </div>
    );
  }
  return (
    <div className="de--label-table-body">
      {expressionList.map(item => (
        <TargetLabelBodyRow row={item} key={item.id} saveLabel={saveLabel} />
      ))}
    </div>
  );
};

TargetLabelBody.propTypes = {
  saveLabel: func,
  expressionList: instanceOf(Array),
  loading: bool,
  selectedTargets: instanceOf(Object),
};

export default TargetLabelBody;
